import { BuyerEnquiryHistory } from 'models/DealRoom';
import {
  getIsDesc,
  getSortBy,
  getSortComparator,
  getUserFullName,
} from 'utils';

export const SORT_VALUES = {
  LEAD: 'lead',
  NUMBER_OF_ENQUIRIES: 'number_of_enquiries',
  LAST_ENQUIRE: 'last_enquire',
};

export const sortPreviousLeads = (
  a: BuyerEnquiryHistory,
  b: BuyerEnquiryHistory,
  sort: string,
) => {
  const isDesc = getIsDesc(sort);
  const sortBy = getSortBy(sort);

  if (sortBy === SORT_VALUES.LAST_ENQUIRE)
    return getSortComparator(b.lastEnquire, a.lastEnquire, isDesc);

  if (sortBy === SORT_VALUES.NUMBER_OF_ENQUIRIES)
    return getSortComparator(
      a.numberOfPreviousEnquiries,
      b.numberOfPreviousEnquiries,
      isDesc,
    );

  return getSortComparator(
    getUserFullName(a.buyerFirstName, a.buyerLastName),
    getUserFullName(b.buyerFirstName, b.buyerLastName),
    isDesc,
  );
};
